export default __webpack_public_path__ + "static/media/d7.181d697c.jpeg";